import ChangePasswordForm from "../components/ChangePasswordForm"
import styles from "../styles/ChangePasswordPage.module.css"

export default function ChangePassword() {

    return (
        <div className={styles.generalContainer}>
            <div className={styles.card}>
                <div className={styles.logoContainer}>
                    <img src="images/cs-loginSoyMomoImage.svg" width={100} height={100} className={styles.momoImg} alt="SoyMomo logo"/>
                </div>

                <h1 className={styles.title}>Nueva contraseña</h1>

                {/* Los carácteres válidos ya no viven en una tarjeta aparte: se
                    muestran dentro del requisito que los pide, y solo mientras
                    ese requisito siga sin cumplirse. */}
                <ChangePasswordForm/>

                <a href="/">
                    <h3 className={styles.link}>Volver a inicio</h3>
                </a>
                <img src="images/cs-loginSoyMomoLogo.svg" width={100} height={100} className={styles.logo} alt="logo"/>
            </div>
        </div>
    )
}
